<script lang="ts" setup>
import type { EsProduct } from '~layers/types/elastic'

export interface Props {
  product: EsProduct
  label?: string
}

const props = defineProps<Props>()

const canShow = computed(() => {
  return props.product.finalPrice >= 1000
    && props.product.saleType !== 'OUTLET'
    && ['Banken', 'Fauteuils'].includes(props.product.groupCode || '')
})

const { openFor } = useOfferFormDialog()
</script>

<template>
  <div
    v-if="canShow"
    class="offer"
  >
    {{ $t('Want to configure the {product} yourself? Request a no-obligation quote or visit one of our stores.', { product: product.name }) }}
    <button
      class="offer__button"
      @click="openFor(product)"
    >
      <span>{{ $t('Request a free quote') }}</span>
    </button>
  </div>
</template>
